import { Divider } from "antd";
import React from "react";
import { Button } from "react-bootstrap";
import ButtonInput from "../../../../../components/common/Button/ButtonInput";
import FilterButton from "../../../../../components/common/Button/FilterButton";
import CustomDatePicker from "../../../../../components/common/DatePicker/CustomDatePicker";
import CustomTable from "../../../../../components/common/Table/CustomTable";
import TextInput from "../../../../../components/common/TextInput/TextInput";
import ExportButton from "../../../components/ExportButton";
import { renderCapitalColumns } from "../constants";

const CapitalTransaction = ({
  handleOutletButtonClick,
  handleDateChange,
  handleReset,
  loading,
  data,
  transactionTypeCount,
  handleTransactionTypeChange,
  handleEnter,
  handleExport,
  pageSizeValue,
  searchNameValue,
  tablePagination,
  handleTableChange,
  handleInputChange,
  dateValue,
  handleDetailButtonClick,
  capitalData,
}) => {
  return (
    <div className="py-3">
      <div className="d-flex filter-bar filter-bar-2">
        <TextInput
          id={"pageSize"}
          label={"Tampilkan"}
          width={"7%"}
          handleEnter={handleEnter}
          value={pageSizeValue}
          handleChange={handleInputChange}
        />
        <TextInput
          id={"searchName"}
          label={"No. SBG / No. Kwitansi / Nama Nasabah"}
          width={"30%"}
          placeholder={"Cari.."}
          handleEnter={handleEnter}
          value={searchNameValue}
          handleChange={handleInputChange}
        />
        <ButtonInput
          id={"outlet"}
          label={"Cabang/Outlet"}
          buttonText={"Pilih Cabang"}
          onButtonClick={handleOutletButtonClick}
          variant={"outline-secondary"}
          width={"13%"}
        />
        <CustomDatePicker
          id={"capitalTransaction"}
          label={"Tanggal Transaksi"}
          isRangePicker
          width="20%"
          onInputChange={handleDateChange}
          value={dateValue}
        />
        <div className="ml-auto">
          <Button
            variant="link"
            className="btn-action btn-reset"
            onClick={handleReset}
          >
            Reset semua filter
          </Button>
        </div>
      </div>

      <div className="d-flex filter-bar-2 align-items-center mt-2 mb-4">
        <span style={{ fontSize: "15px" }}>Jenis Transaksi:</span>
        {transactionTypeCount.map((transactionCount) => {
          return (
            <FilterButton
              data={transactionCount}
              handleChange={handleTransactionTypeChange}
              type="transactionType"
            />
          );
        })}
      </div>

      <div style={{ marginBottom: "1.5rem" }}>
        <div className="d-flex justify-content-between total-outer-container">
          <div className="total-summary-container">
            <div className="total-value">{capitalData?.capital || 0}</div>
            <div className="total-label">Modal Awal</div>
          </div>
          <Divider className="total-divider" type="vertical" />
          <div className="total-summary-container">
            <div className="total-value text-success">{capitalData?.income || 0}</div>
            <div className="total-label">Total Pemasukan</div>
          </div>
          <Divider className="total-divider" type="vertical" />
          <div className="total-summary-container">
            <div className="total-value text-danger">{capitalData?.expense || 0}</div>
            <div className="total-label">Total Pengeluaran</div>
          </div>
          <Divider className="total-divider" type="vertical" />
          <div className="total-summary-container">
            <div className="total-value">{capitalData?.totalCapital || 0}</div>
            <div className="total-label">Modal Akhir</div>
          </div>
        </div>
      </div>

      <CustomTable
        columns={renderCapitalColumns(handleDetailButtonClick)}
        data={data}
        loading={loading}
        handleTableChange={handleTableChange}
        pagination={tablePagination}
      />

      <div className="filter-bar-2 d-flex" style={{ marginTop: "2rem" }}>
        <ExportButton
          handleExport={handleExport}
          pathname="/history/capital/export"
          data={data}
          from="capital"
          columns={renderCapitalColumns()}
        />
      </div>
    </div>
  );
};

export default CapitalTransaction;
